// get started for each activity
import { Button, Stack, Typography } from "@mui/material"
import { t } from "i18next"
import { Trans } from "react-i18next"
import { doArrow, popoverStyles } from "./styles/GetStarted.styles"
// import { getStarted } from "utils/images"
import Image from "components/Image"
import "@reactour/popover/dist/index.css"
import { theme } from "themes/default/theme"
import EastIcon from "@mui/icons-material/East"
import GetStartedBuble from "components/GetStarted/GetStartedBuble"
import { isMobile } from "react-device-detect"

export const popoverRadius = 5
export const popoverZindex = 100000

export const nextStyles = {
  minWidth: 0,
  alignSelf: "flex-end",
  textTransform: "none",
  fontSize: "0.75rem",
  // position: "absolute",
  // bottom: -30,
  // right: 0,
  backgroundColor: theme.palette.common.white,
  color: "#2d2d2d",
  border: `1px solid #ccc`,
  borderRadius: "3px",
  padding: "2px 22px",
  textShadow: `1px 1px 0 #fff`,
  font: `12px/normal sans-serif`,
  outline: 0,
  zoom: 1,
  lineHeight: 1.3,
  "&:hover": {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },
  "& svg": {
    width: 20,
    height: 20,
    fontSize: 16,
  },
}

const ExplanationGetStarted = [
  // {
  //     target: "body",
  //     content: <h2>Welcome to the Explanation activity</h2>,
  //     position: "center",
  // },
  {
    id: "explanation-activity",
    target: "#stop-recording",
    selector: "#stop-recording",
    highlightedSelectors: ["#stop-recording"],
    mutationObservables: ["#stop-recording"],
    content: ({ setIsOpen, currentStep, setCurrentStep }) => (
      <GetStartedBuble
        text="you_can_stop_recording_here"
        audioLink="explanation_you_can_stop_recording_here"
        forceShow
        showImage
        imagePosition="right"
        audioCallback={() => {
          setIsOpen(false)
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "right",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
  {
    id: "explanation-activity",
    target: ".next-exercise",
    selector: ".next-exercise",
    highlightedSelectors: [".next-exercise"],
    mutationObservables: [".next-exercise"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="click_on_next_to_continue"
        audioLink="explanation_click_on_next_to_continue"
        showImage
        imagePosition="left"
        forceShow
        customImageStyle={{
          top: -240,
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "top",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
]

const ExplanationVideo = [
  {
    id: "explanation-video",
    target: ".next-exercise",
    selector: ".next-exercise",
    highlightedSelectors: [".next-exercise"],
    mutationObservables: [".next-exercise"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text={"click_on_next_to_continue"}
        showAudio
        audioLink="explanation_click_on_next_to_continue"
        showImage
        imagePosition="left"
        forceShow
        customImageStyle={{
          top: -240,
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
      // <Trans i18nKey={"click_on_next_to_continue"}>
      //   <Typography>{t("click_on_next_to_continue")}</Typography>
      // </Trans>
    ),
    position: "top",
    styles: {
      ...popoverStyles,
    },
  },
]

const PictureQuestionGetStartedForzed = (audioRef) => {
  return [
    {
      id: "picture-question",
      selector: ".photo-text-container",
      highlightedSelectors: [".photo-text-container"],
      mutationObservables: [".photo-text-container"],
      content: ({ setIsOpen }) => (
        <GetStartedBuble
          text={t("select_the_correct_answer")}
          showAudio
          audioLink="select_the_correct_answer"
          showImage
          imagePosition="right"
          image={17}
          audioCallback={() => {
            console.log(audioRef, "audioRef")
            audioRef()
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "right",
      styles: {
        popover: (base, state) => ({
          ...popoverStyles.popover(base, state),
          marginTop: "5%",
          marginLeft: 25,
        }),
      },
    },
  ]
}

const PictureQuestionGetStarted = [
  {
    id: "picture-question",
    selector: ".photo-text-container",
    highlightedSelectors: [".photo-text-container"],
    mutationObservables: [".photo-text-container"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text={t("select_the_correct_answer")}
        showAudio
        audioLink="select_the_correct_answer"
        showImage
        imagePosition="right"
        image={17}
        forceShow
        audioCallback={() => {
          const audioButton = document.querySelector("#stop-recording")
          // if audioButton contain class sound-button-playing then click button to stop audio
          if (
            audioButton &&
            !audioButton?.classList?.contains("sound-button-playing")
          ) {
            audioButton.click()
          }
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "right",
    styles: {
      popover: (base, state) => ({
        ...popoverStyles.popover(base, state),
        marginTop: "5%",
        marginLeft: 25,
      }),
    },
  },
]

const MatchingPictureForzedGetStarted = (
  imagePosition = "right",
  carouselRef
) => {
  return [
    {
      id: "matching-picture",
      selector: ".carousel-nav-items",
      highlightedSelectors: [".carousel-nav-items"],
      mutationObservables: [".carousel-nav-items"],
      content: ({ setIsOpen }) => (
        <GetStartedBuble
          key={`matching-picture-3`}
          text={t("select_the_picture_that_corresponds")}
          showAudio
          audioLink="selectThePictureThatCorresponds"
          showImage
          imagePosition={imagePosition}
          audioCallback={() => {
            console.log(carouselRef, "carouselRef")
            carouselRef?.current?.playCurrentSound()
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: imagePosition,
      styles: popoverStyles,
    },
    {
      id: "matching-picture",
      selector: ".matching-item-selected",
      highlightedSelectors: [".matching-item-selected"],
      mutationObservables: [".matching-item-selected"],
      content: ({ setIsOpen, currentStep, setCurrentStep }) => (
        <GetStartedBuble
          key={`matching-picture-4`}
          text={t("click_on_the_picture_to_send_back_the_answer_selected_2")}
          showAudio
          audioLink="listen_and_choose_click_on_the_picture_to_send_back_the_answer_selected"
          showImage
          image={11}
          imagePosition="right"
          checkCss
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "right",
      className: "test-class",
      styles: popoverStyles,
    },
  ]
}

const MatchingPictureGetStarted = [
  {
    id: "matching-picture",
    selector: ".carousel-nav-items",
    highlightedSelectors: [".carousel-nav-items"],
    mutationObservables: [".carousel-nav-items"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        key={`matching-picture-1`}
        text={t("select_the_picture_that_corresponds")}
        showAudio
        audioLink="selectThePictureThatCorresponds"
        showImage
        imagePosition="right"
        forceShow
        checkCss
        audioCallback={() => {
          const audioButton = document.querySelector("#stop-recording")
          // if audioButton contain class sound-button-playing then click button to stop audio
          if (
            audioButton &&
            !audioButton?.classList?.contains("sound-button-playing")
          ) {
            audioButton.click()
          }
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "right",
    styles: popoverStyles,
  },
  {
    id: "matching-picture",
    selector: ".matching-item-selected",
    highlightedSelectors: [".matching-item-selected"],
    mutationObservables: [".matching-item-selected"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        key={`matching-picture-2`}
        text={t("click_on_the_picture_to_send_back_the_answer_selected_2")}
        showAudio
        audioLink="listen_and_choose_click_on_the_picture_to_send_back_the_answer_selected"
        showImage
        imagePosition="right"
        image={11}
        checkCss
        forceShow
        customImageStyle={{
          top: -150,
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "right",
    className: "test-class",
    styles: popoverStyles,
  },
]

const ListenAndChooseGetStarted = [
  {
    id: "listen-and-choose",
    selector: ".carousel-nav-items",
    highlightedSelectors: [".carousel-nav-items"],
    mutationObservables: [".carousel-nav-items"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text={t("listen_to_the_recording_and_select_the_picture")}
        forceShow
        audioLink="listen_and_choose_listen_to_the_recording_and_select_the_picture"
        imagePosition="right"
        showImage
        checkCss
        audioCallback={() => {
          const audioButton = document.querySelector("#stop-recording")
          // if audioButton contain class sound-button-playing then click button to stop audio
          if (
            audioButton &&
            !audioButton?.classList?.contains("sound-button-playing")
          ) {
            audioButton.click()
          }
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "right",
    styles: {
      ...popoverStyles,
    },
  },
  {
    id: "listen-and-choose",
    selector: ".matching-item-selected",
    highlightedSelectors: [".matching-item-selected"],
    mutationObservables: [".matching-item-selected"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="click_on_the_picture_to_send_back_the_answer_selected_2"
        audioLink="listen_and_choose_click_on_the_picture_to_send_back_the_answer_selected"
        imagePosition="right"
        showImage
        checkCss
        forceShow
      />
    ),
    position: "left",
    styles: {
      ...popoverStyles,
    },
  },
]
const FindThePictureGetStarted = [
  {
    id: "find-the-picture",
    selector: ".question-item",
    highlightedSelectors: [".question-item"],
    mutationObservables: [".question-item"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text={"select_the_picture_that_corresponds_to_the_text"}
        audioLink="find_the_picture_select_the_picture_that_corresponds"
        forceShow
        showImage
        imagePosition="right"
        audioCallback={() => {
          const audioButton = document.querySelector("#stop-recording")
          if (
            audioButton &&
            !audioButton?.classList?.contains("sound-button-playing")
          ) {
            audioButton.click()
          }
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "right",
    styles: {
      ...popoverStyles,
    },
  },
]

const ListenAndFindThePictureGetStarted = [
  {
    id: "listen-find-the-picture",
    selector: ".question-item",
    highlightedSelectors: [".question-item"],
    mutationObservables: [".question-item"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text={"select_the_picture_that_corresponds_to_the_audio"}
        audioLink="listen_and_find_the_picture_select_the_picture_that_corresponds_to_the_audio"
        forceShow
        showImage
        imagePosition="right"
        audioCallback={() => {
          const audioButton = document.querySelector("#stop-recording")
          if (
            audioButton &&
            !audioButton?.classList?.contains("sound-button-playing")
          ) {
            audioButton.click()
          }
        }}
      />
    ),
    position: "right",
    styles: {
      ...popoverStyles,
    },
  },
]

const MatchingGetStateted = [
  {
    id: "matching",
    selector: ".carousel-nav-items",
    highlightedSelectors: [".hidden-carousel-nav-items"],
    mutationObservables: [".hidden-carousel-nav-items"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="select_the_word_that_corresponds_to_the_word"
        audioLink="matching_select_the_word_that_corresponds_to_the_word"
        forceShow
        showImage
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: isMobile
      ? "bottom"
      : [
          /// left 50% of current screen
          window.innerWidth / 2 - 350,
          /// top 50% of current screen
          200,
        ],
    styles: {
      popover: (base, state) => ({
        ...popoverStyles.popover(base, state),
        marginTop: isMobile ? 65 : 0,
        ...doArrow("left", "top", "center"),
      }),
    },
  },
  {
    id: "matching",
    selector: ".item-option-selected",
    highlightedSelectors: [".item-option-selected"],
    mutationObservables: [".item-option-selected"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="click_on_your_answer_to_send_it_back"
        audioLink="matching_click_on_your_answer_to_send_it_back"
        forceShow
        showImage
        imagePosition="right"
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "right",
    styles: {
      ...popoverStyles,
    },
  },
]

const ScrambledSentenceGetStarted = [
  {
    id: "scrambled-sentence",
    selector: ".items-answers",
    highlightedSelectors: [".items-answers"],
    mutationObservables: [".items-answers"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="select_the_words_in_the_right_order"
        audioLink="scrambled_sentences_select_the_words_in_the_right_order"
        forceShow
        showImage
        imagePosition="right"
        customImageStyle={{
          top: -165,
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "top",
    styles: {
      ...popoverStyles,
    },
  },
  {
    id: "scrambled-sentence",
    selector: ".item-answer-selected",
    highlightedSelectors: [".item-answer-selected"],
    mutationObservables: [".item-answer-selected"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="click_on_your_answer_to_send_it_back"
        audioLink="scrambled_sentences_click_on_your_answer_to_send_it_back"
        forceShow
        showImage
        imagePosition="right"
        image={15}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "right",
    styles: {
      ...popoverStyles,
    },
  },
  {
    id: "scrambled-sentence",
    selector: ".exercise-answer",
    highlightedSelectors: [".exercise-answer"],
    mutationObservables: [".exercise-answer"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="this_is_the_expected_answer"
        audioLink="scrambled_sentences_this_is_the_expected_answer"
        forceShow
        showImage
        imagePosition="right"
        image={10}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    styles: {
      ...popoverStyles,
    },
  },
]

const SoackedManGetStarted = [
  {
    id: "soaked-man",
    target: "#stop-recording",
    selector: "#stop-recording",
    highlightedSelectors: ["#stop-recording"],
    mutationObservables: ["#stop-recording"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="listen_to_the_recording"
        audioLink="soacked_man_listen_to_the_recording"
        forceShow
        showImage
        imagePosition="right"
        audioCallback={() => {
          const audioButton = document.querySelector("#stop-recording")
          // if audioButton contain class sound-button-playing then click button to stop audio
          if (
            audioButton &&
            !audioButton?.classList?.contains("sound-button-playing")
          ) {
            audioButton.click()
          }
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
      // <Trans i18nKey={"listen_to_the_recording"}>
      //   {" "}
      //   <Typography>{t("listen_to_the_recording")}</Typography>
      // </Trans>
    ),
    position: "right",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
]

const WordsPronounciationGetStarted = [
  {
    id: "words-pronounciation",
    target: ".speech-button",
    selector: ".speech-button",
    highlightedSelectors: [".speech-button"],
    mutationObservables: [".speech-button"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="click_in_the_microphone_and_response_to_the_question"
        audioLink="words_pronounciation_click_in_the_microphone_and_response_to_the_question"
        forceShow
        showImage
        imagePosition="right"
        image={17}
        audioCallback={() => {
          setTimeout(() => {
            const soundButton = document.getElementById("stop-recording")
            // if soundButton doesnt has class wave-play-button-playing
            if (
              soundButton &&
              !soundButton.classList.contains("sound-button-playing")
            ) {
              soundButton.click()
            }
          }, 500)
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "right",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
]

const SentencePronounciationGetStarted = [
  {
    id: "sentence-pronounciation",
    target: ".speech-button",
    selector: ".speech-button",
    highlightedSelectors: [".speech-button"],
    mutationObservables: [".speech-button"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="click_in_the_microphone_and_repeat_the_sentence"
        audioLink="sentences_pronounciation_click_in_the_microphone_and_repeat_the_sentence"
        forceShow
        showImage
        imagePosition="right"
        image={17}
        audioCallback={() => {
          setTimeout(() => {
            const soundButton = document.getElementById("wave-play-button")
            // if soundButton doesnt has class wave-play-button-playing
            if (
              soundButton &&
              !soundButton.classList.contains("wave-play-button-playing")
            ) {
              soundButton.click()
            }
          }, 500)
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "right",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
]

const ReadingOutloudGetStarted = [
  {
    id: "reading-outloud",
    target: ".speech-button",
    selector: ".speech-button",
    highlightedSelectors: [".speech-button"],
    mutationObservables: [".speech-button"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="click_on_the_microphone_and_read_the_sentence_in_blue"
        audioLink="reading_outloud_click_on_the_microphone_and_read_the_sentence_in_blue"
        forceShow
        showImage
        imagePosition="left"
        customImageStyle={{
          top: -160,
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "left",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
]

const InteractionsGetStated = [
  {
    id: "interactions",
    target: ".begin-button",
    selector: ".begin-button",
    highlightedSelectors: [".begin-button"],
    mutationObservables: [".begin-button"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        textComponent={
          <Typography component={"span"}>
            {" "}
            <Trans i18nKey={"click_in_retake"}>
              {t("click_in_retake")}
            </Trans>{" "}
            <Typography component={"span"} fontWeight={"bold"}>
              <Trans i18nKey={"begin"}>{t("begin")}</Trans>
            </Typography>
          </Typography>
        }
        showAudio
        audioLink="click_in_begin"
        showImage
        imagePosition="left"
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "left",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
  {
    id: "interactions",
    target: ".speech-button",
    selector: ".speech-button",
    highlightedSelectors: [".speech-button"],
    mutationObservables: [".speech-button"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text={"click_in_the_microphone_and_pronounce_your_part"}
        showAudio
        audioLink="click_in_the_microphone_and_pronounce_your_part"
        showImage
        imagePosition="left"
        forceShow
        customImageStyle={{
          top: -170,
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "top",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
]

const FillingTheBlanksGetStated = [
  {
    id: "filling-the-blanks",
    selector: "#words-options",
    highlightedSelectors: ["#words-options"],
    mutationObservables: ["#words-options"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="select_the_words_that_complete_the_text"
        audioLink="filling_the_blanks_select_the_words_that_complete_the_text"
        forceShow
        showImage
        customImageStyle={{
          right: 400,
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "top",
    styles: {
      ...popoverStyles,
    },
  },
]

const FillingTheBlanksWriteGetStated = [
  {
    id: "filling-the-blanks-write",
    selector: ".filling-input",
    highlightedSelectors: [".filling-input"],
    mutationObservables: [".filling-input"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="write_the_words_that_complete_the_text"
        audioLink="filling_the_blanks_write_write_the_words_that_complete_the_text"
        forceShow
        showImage
        imagePosition="right"
        image={17}
        audioCallback={() => {
          setIsOpen(false)
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "bottom",
    styles: {
      ...popoverStyles,
    },
  },
]

const PictureAndQuestionWriteGetStartedForzed = (audioRef) => {
  return [
    {
      id: "picture-and-question-write",
      selector: ".picture-and-question-write-keyboard",
      highlightedSelectors: [".picture-and-question-write-keyboard"],
      mutationObservables: [".picture-and-question-write-keyboard"],
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          showImage
          imagePosition={"right"}
          image={17}
          text="use_the_specials_characters_when_needed"
          showAudio
          audioLink="use_the_specials_characters_when_needed"
          showNextButton
          onNextClick={() => setCurrentStep(currentStep + 1)}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "bottom",
      styles: {
        ...popoverStyles,
      },
    },
    {
      id: "picture-and-question-write",
      selector: ".input-answer",
      highlightedSelectors: [".input-answer"],
      mutationObservables: [".input-answer"],
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          text="write_your_answer"
          audioLink="write_your_answer"
          showNextButton
          onNextClick={() => setCurrentStep(currentStep + 1)}
          showBackButton
          onBackClick={() => setCurrentStep(currentStep - 1)}
          showImage
          image={17}
          imagePosition={"right"}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "bottom",
      styles: {
        ...popoverStyles,
      },
    },
    {
      id: "picture-and-question-write",
      selector: ".verify-btn",
      highlightedSelectors: [".verify-btn"],
      mutationObservables: [".verify-btn"],
      content: ({ setIsOpen, currentStep, setCurrentStep }) => (
        <GetStartedBuble
          text="and_click_on_verify_when_done"
          audioLink="click_on_verify_when_finished"
          showNextButton
          onNextClick={() => setIsOpen(false)}
          showBackButton
          onBackClick={() => setCurrentStep(currentStep - 1)}
          image={17}
          showImage
          imagePosition={"right"}
          audioCallback={() => {
            console.log(audioRef, "audioRef")
            setTimeout(() => {
              audioRef()
            }, 1000)
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "top",
      styles: {
        ...popoverStyles,
      },
    },
  ]
}

const PictureAndQuestionWriteGetStarted = [
  {
    id: "picture-and-question-write",
    selector: ".picture-and-question-write-keyboard",
    highlightedSelectors: [".picture-and-question-write-keyboard"],
    mutationObservables: [".picture-and-question-write-keyboard"],
    content: ({ setCurrentStep, currentStep, setIsOpen }) => (
      <GetStartedBuble
        showImage
        imagePosition={"right"}
        image={17}
        text="use_the_specials_characters_when_needed"
        showAudio
        audioLink="use_the_specials_characters_when_needed"
        showNextButton
        onNextClick={() => setCurrentStep(currentStep + 1)}
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "bottom",
    styles: {
      ...popoverStyles,
    },
  },
  {
    id: "picture-and-question-write",
    selector: ".input-answer",
    highlightedSelectors: [".input-answer"],
    mutationObservables: [".input-answer"],
    content: ({ setCurrentStep, currentStep, setIsOpen }) => (
      <GetStartedBuble
        text="write_your_answer"
        audioLink="write_your_answer"
        showNextButton
        onNextClick={() => setCurrentStep(currentStep + 1)}
        showBackButton
        onBackClick={() => setCurrentStep(currentStep - 1)}
        showImage
        image={17}
        imagePosition={"right"}
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "bottom",
    styles: {
      ...popoverStyles,
    },
  },
  {
    id: "picture-and-question-write",
    selector: ".verify-btn",
    highlightedSelectors: [".verify-btn"],
    mutationObservables: [".verify-btn"],
    content: ({ setIsOpen, currentStep, setCurrentStep }) => (
      <GetStartedBuble
        text="and_click_on_verify_when_done"
        audioLink="click_on_verify_when_finished"
        showNextButton
        onNextClick={() => setIsOpen(false)}
        showBackButton
        onBackClick={() => setCurrentStep(currentStep - 1)}
        image={17}
        showImage
        imagePosition={"right"}
        forceShow
        audioCallback={() => {
          const audioButton = document.querySelector("#stop-recording")
          // if audioButton contain class sound-button-playing then click button to stop audio
          if (
            audioButton &&
            !audioButton?.classList?.contains("sound-button-playing")
          ) {
            audioButton.click()
          }
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "top",
    styles: {
      ...popoverStyles,
    },
  },
]

const DictationGetStarted = [
  {
    id: "dictation",
    selector: ".input-answer",
    highlightedSelectors: [".input-answer"],
    mutationObservables: [".input-answer"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="write_the_words_you_heard"
        audioLink="dictation_write_the_words_you_heard"
        forceShow
        showImage
        imagePosition="right"
        audioCallback={() => {
          const audioButton = document.querySelector("#stop-recording")
          // if audioButton contain class sound-button-playing then click button to stop audio
          if (
            audioButton &&
            !audioButton?.classList?.contains("sound-button-playing")
          ) {
            audioButton.click()
          }
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "right",
    styles: {
      ...popoverStyles,
    },
  },
]

const OralComprehensionGetStarted = [
  {
    id: "oral-comprehension",
    selector: ".recording-input",
    highlightedSelectors: [".recording-input"],
    mutationObservables: [".recording-input"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="listen_the_recording"
        audioLink="oral_comprehension_listen_the_recording"
        forceShow
        showImage
        imagePosition="right"
        image={17}
        audioCallback={() => {
          setIsOpen(false)
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "top",
    styles: {
      ...popoverStyles,
    },
  },
  {
    id: "oral-comprehension",
    selector: ".items-options",
    highlightedSelectors: [".items-options"],
    mutationObservables: [".items-options"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="answer_all_the_questions"
        audioLink="oral_comprehension_answer_all_the_questions"
        forceShow
        showImage
        imagePosition="left"
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "right",
    styles: {
      ...popoverStyles,
    },
  },
]

const TextComprehensionGetStarted = [
  {
    id: "text-comprehension",
    selector: ".text-to-read",
    highlightedSelectors: [".text-to-read"],
    mutationObservables: [".text-to-read"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="read_the_text"
        audioLink="text_comprehension_read_the_passage"
        forceShow
        showImage
        imagePosition="right"
        image={10}
        customImageStyle={{
          top: -215,
        }}
        audioCallback={() => {
          setIsOpen(false)
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "bottom",
    styles: {
      ...popoverStyles,
    },
  },
]

const WrittenComprehensionGetStarted = [
  {
    id: "written-comprehension",
    selector: ".text-to-read",
    highlightedSelectors: [".text-to-read"],
    mutationObservables: [".text-to-read"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="read_the_passage"
        audioLink="written_comprehension_read_the_passage"
        forceShow
        showImage
        imagePosition="right"
        image={10}
        customImageStyle={{
          top: -215,
        }}
        audioCallback={() => {
          setIsOpen(false)
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "bottom",
    styles: {
      ...popoverStyles,
    },
  },
]

const RecordingComprehensionGetStarted = [
  {
    id: "recording-comprehension",
    selector: ".recording-input",
    highlightedSelectors: [".recording-input"],
    mutationObservables: [".recording-input"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="listen_the_recording_and_read_along"
        audioLink="recording_comprehension_listen_to_the_recording_and_read_along"
        forceShow
        showImage
        imagePosition="right"
        image={10}
        audioCallback={() => {
          setIsOpen(false)
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "bottom",
    styles: {
      ...popoverStyles,
    },
  },
]

const JustWriteGetStarted = [
  {
    id: "just-write",
    selector: "#box-student ",
    highlightedSelectors: ["#box-student "],
    mutationObservables: ["#box-student "],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="read_the_instrucctions_write_your_answers"
        audioLink="just_write_read_the_instrucctions_write_your_answers"
        forceShow
        showImage
        customImageStyle={{
          top: -90,
        }}
        audioCallback={() => {
          setIsOpen(false)
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "top",
    styles: {
      ...popoverStyles,
    },
  },
]

const JustWriteMultipleGetStarted = [
  {
    id: "just-write-multiple",
    selector: ".input-answer",
    highlightedSelectors: [".input-answer"],
    mutationObservables: [".input-answer"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="respond_to_each_question_and_submit"
        audioLink="just_write_multiple_respond_to_each_question_and_submit"
        forceShow
        showImage
        imagePosition="right"
        image={10}
        audioCallback={() => {
          setIsOpen(false)
        }}
        checkCss
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "bottom",
    styles: {
      ...popoverStyles,
    },
  },
]

const InterviewGetStarted = [
  {
    id: "interview",
    target: ".begin-button",
    selector: ".begin-button",
    highlightedSelectors: [".begin-button"],
    mutationObservables: [".begin-button"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        forceShow
        audioLink="click_in_begin"
        showImage
        textComponent={
          <Typography component={"span"}>
            {" "}
            <Trans i18nKey="click_in_retake">{t("click_in_retake")}</Trans>{" "}
            <Typography fontWeight={"bold"} component={"span"}>
              <Trans i18nKey="begin">{t("begin")}</Trans>
            </Typography>
          </Typography>
        }
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "left",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
  {
    id: "interview",
    target: ".mic-button",
    selector: ".mic-button",
    highlightedSelectors: [".mic-button"],
    mutationObservables: [".mic-button"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        forceShow
        text="click_in_the_microphone_and_respond_to_each_question"
        audioLink="interview_click_in_the_microphone_and_respond_to_each_question"
        showAudio
        showImage
        image={10}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "top",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
]

const InterviewForcedGetStarted = [
  {
    id: "interview",
    target: ".begin-button",
    selector: ".begin-button",
    highlightedSelectors: [".begin-button"],
    mutationObservables: [".begin-button"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        textComponent={
          <Typography component={"span"}>
            {" "}
            <Trans i18nKey="click_in_retake">{t("click_in_retake")}</Trans>{" "}
            <Typography fontWeight={"bold"} component={"span"}>
              <Trans i18nKey="begin">{t("begin")}</Trans>
            </Typography>
          </Typography>
        }
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "left",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
  {
    id: "interview",
    target: ".mic-button",
    selector: ".mic-button",
    highlightedSelectors: [".mic-button"],
    mutationObservables: [".mic-button"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="click_in_the_microphone_and_respond_to_each_question"
        audioLink="click_in_the_microphone_and_respond_to_each_question"
        showAudio
        showImage
        image={10}
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "top",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
]

const InterviewGetStarted2 = [
  {
    id: "interview-2",
    target: ".submit-teacher-button",
    selector: ".submit-teacher-button",
    highlightedSelectors: [".submit-teacher-button"],
    mutationObservables: [".submit-teacher-button"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        forceShow
        text="submit_your_answer_to_your_teacher"
        audioLink="submit_your_answer_to_your_teacher"
        showAudio
        showImage
        image={10}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "bottom",
  },
]

const JustTalkGetStarted = [
  {
    id: "just-talk",
    target: ".record-button",
    selector: ".record-button",
    highlightedSelectors: [".record-button"],
    mutationObservables: [".record-button"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="click_on_the_microphone_to_record_your_answer"
        audioLink="just_talk_click_on_the_microphone_to_record_your_answer"
        showAudio
        showImage
        image={10}
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "bottom",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
]

const EssayGetStarted = [
  {
    id: "essay",
    selector: ".splide__arrow--next",
    highlightedSelectors: [".splide__arrow--next"],
    mutationObservables: [".splide__arrow--next"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="look_and_listen_to_the_different_resources"
        audioLink="essay_look_and_listen_to_the_different_resources"
        showAudio
        showImage
        image={10}
        forceShow
        audioCallback={() => {
          setIsOpen(false)
        }}
        customImageStyle={{
          top: -90,
          right: 400,
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "top",
    styles: {
      ...popoverStyles,
    },
  },
  // {
  //   id: "essay",
  //   selector: "#box-student textarea",
  //   highlightedSelectors: ["#box-student textarea"],
  //   mutationObservables: ["#box-student textarea"],
  //   content: (
  //     <Trans i18nKey="react_the_instrucction_and_write_your_essay">
  //       <Typography>
  //         {t("react_the_instrucction_and_write_your_essay")}
  //       </Typography>
  //     </Trans>
  //   ),
  //   position: "right",
  //   styles: {
  //     ...popoverStyles,
  //   },
  // },
]

const MultipleQuestionsGetStarted = [
  {
    id: "multiple-questions",
    selector: ".question-content",
    highlightedSelectors: [".question-content"],
    mutationObservables: [".question-content"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="answer_each_and_every_question"
        audioLink="multiple_question_answer_each_and_every_question"
        forceShow
        showImage
        image={10}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "left",
    styles: {
      ...popoverStyles,
    },
  },
]

const ComparativeEssayGetStarted = [
  {
    id: "just-talk",
    target: ".record-button",
    selector: ".record-button",
    highlightedSelectors: [".record-button"],
    mutationObservables: [".record-button"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="click_on_the_microphone_to_record_your_answer"
        audioLink="comparative_essay_click_on_the_microphone_to_record_your_answer"
        showAudio
        showImage
        image={10}
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "bottom",
    styles: {
      ...popoverStyles,
      maskArea: (base) => ({ ...base, rx: "50%" }),
    },
  },
  {
    id: "just-write",
    selector: "#box-student ",
    highlightedSelectors: ["#box-student "],
    mutationObservables: ["#box-student "],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="react_the_instrucction_and_write_your_comparative_essay"
        audioLink="comparative_essay_read_the_instrucctions_write_your_answers"
        forceShow
        showImage
        customImageStyle={{
          top: -90,
        }}
        audioCallback={() => {
          setIsOpen(false)
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    position: "top",
    styles: {
      ...popoverStyles,
    },
  },
]

// const ComparativeEssayGetStarted = [
//   ...JustTalkGetStarted,
//   ...JustWriteGetStarted,
// ]

const SpeechSideNoMicGetStarted = [
  {
    id: "speech-side-no-mic",
    position: "center",
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text={"smash_requires_the_use_of_a_microphone"}
        image={6}
        imagePosition="left"
        audioLink={"smash_requires_the_use_of_a_microphone"}
        showImage
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    styles: popoverStyles,
  },
]

/** */
const SpeechSideGetStarted = [
  {
    id: "speech-side",
    position: "center",
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text={
          "some_activities_require_the_use_of_a_microphone_grant_permission_to_smash"
        }
        image={6}
        imagePosition="left"
        audioLink={
          "some_activities_require_the_use_of_a_microphone_grant_permission_to_smash"
        }
        showImage
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    styles: popoverStyles,
  },
  {
    id: "speech-side",
    position: "center",
    content: ({ setCurrentStep, currentStep, setIsOpen }) => (
      <GetStartedBuble
        textComponent={
          <Stack alignItems={"center"}>
            <Trans i18nKey="for_better_results_when_speaking">
              <Typography textAlign={"center"} color="primary">
                {t("for_better_results_when_speaking") + ":"}
              </Typography>
            </Trans>
            <Image name="headset" width={80} height={80} />
            <Trans i18nKey="use_a_headset_or_a_headphone">
              <Typography textAlign={"center"}>
                {t("use_a_headset_or_a_headphone")}
              </Typography>
            </Trans>
          </Stack>
        }
        image={"getStarted1"}
        imagePosition="left"
        audioLink={"use_a_headset_or_a_headphone"}
        showImage
        showNextButton
        onNextClick={() => setCurrentStep(currentStep + 1)}
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    styles: popoverStyles,
  },
  {
    id: "speech-side",
    position: "center",
    content: ({ setCurrentStep, currentStep, setIsOpen }) => (
      <GetStartedBuble
        textComponent={
          <Stack alignItems={"center"}>
            <Trans i18nKey="for_better_results_when_speaking">
              <Typography textAlign={"center"} color="primary">
                {t("for_better_results_when_speaking") + ":"}
              </Typography>
            </Trans>
            <Image name="headset" width={80} height={80} />
            <Trans i18nKey="reduce_the_background_noises">
              <Typography textAlign={"center"}>
                {t("reduce_the_background_noises")}
              </Typography>
            </Trans>
          </Stack>
        }
        image={"getStarted1"}
        imagePosition="left"
        audioLink={"reduce_the_background_noises"}
        showImage
        showNextButton
        showBackButton
        onNextClick={() => setCurrentStep(currentStep + 1)}
        onBackClick={() => setCurrentStep(currentStep - 1)}
        onSkipClick={() => {
          setIsOpen(false)
        }}
        forceShow
      />
    ),
    styles: popoverStyles,
  },
  {
    id: "speech-side",
    target: ".speech-button-settings",
    selector: ".speech-button-settings",
    highlightedSelectors: [".speech-button-settings"],
    mutationObservables: [".speech-button-settings"],
    position: "right",
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text={"lets_make_sure_your_microphone_is_working_fine"}
        image={17}
        imagePosition="right"
        audioLink={"lets_make_sure_your_microphone_is_working_fine"}
        showImage
        customImageStyle={{
          top: -195,
        }}
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    styles: popoverStyles,
  },
]

const SpeechSideGetStartedFirefox = [
  {
    id: "speech-side",
    position: "center",
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text={
          "some_activities_require_the_use_of_a_microphone_grant_permission_to_smash"
        }
        image={6}
        imagePosition="left"
        audioLink={
          "some_activities_require_the_use_of_a_microphone_grant_permission_to_smash"
        }
        showImage
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    styles: popoverStyles,
  },
  {
    id: "speech-side",
    position: "center",
    content: ({ setCurrentStep, currentStep, setIsOpen }) => (
      <GetStartedBuble
        textComponent={
          <Stack alignItems={"center"}>
            <Trans i18nKey="for_better_results_when_speaking">
              <Typography textAlign={"center"} color="primary">
                {t("for_better_results_when_speaking") + ":"}
              </Typography>
            </Trans>
            <Image name="headset" width={80} height={80} />
            <Trans i18nKey="use_a_headset_or_a_headphone">
              <Typography textAlign={"center"}>
                {t("use_a_headset_or_a_headphone")}
              </Typography>
            </Trans>
          </Stack>
        }
        image={"getStarted1"}
        imagePosition="left"
        audioLink={"use_a_headset_or_a_headphone"}
        showImage
        showNextButton
        onNextClick={() => setCurrentStep(currentStep + 1)}
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    styles: popoverStyles,
  },
  {
    id: "speech-side",
    position: "center",
    content: ({ setCurrentStep, currentStep, setIsOpen }) => (
      <GetStartedBuble
        textComponent={
          <Stack alignItems={"center"}>
            <Trans i18nKey="for_better_results_when_speaking">
              <Typography textAlign={"center"} color="primary">
                {t("for_better_results_when_speaking") + ":"}
              </Typography>
            </Trans>
            <Image name="headset" width={80} height={80} />
            <Trans i18nKey="reduce_the_background_noises">
              <Typography textAlign={"center"}>
                {t("reduce_the_background_noises")}
              </Typography>
            </Trans>
          </Stack>
        }
        image={"getStarted1"}
        imagePosition="left"
        audioLink={"reduce_the_background_noises"}
        showImage
        showNextButton
        showBackButton
        onNextClick={() => setCurrentStep(currentStep + 1)}
        onBackClick={() => setCurrentStep(currentStep - 1)}
        onSkipClick={() => {
          setIsOpen(false)
        }}
        forceShow
      />
    ),
    styles: popoverStyles,
  },
  {
    id: "speech-levels",
    target: ".speech-button",
    selector: ".speech-button",
    highlightedSelectors: [".speech-button"],
    mutationObservables: [".speech-button"],
    position: "center",
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        forceShow
        textComponent={
          <Stack alignItems={"center"}>
            <Trans i18nKey="for_better_results_when_speaking">
              <Typography textAlign={"center"} color="primary">
                {t("for_better_results_when_speaking") + ":"}
              </Typography>
            </Trans>
            <Image name="microphone" width={80} height={80} />
            <Trans i18nKey="click_on_the_microphone_to_start_speaking_speak_clearly">
              <Typography textAlign={"center"}>
                {t("click_on_the_microphone_to_start_speaking_speak_clearly")}
              </Typography>
            </Trans>
          </Stack>
        }
        image={17}
        imagePosition="left"
        audioLink={"click_on_the_microphone_to_start_speaking_speak_clearly"}
        showImage
        customImageStyle={{
          right: 400,
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
  },
]

const SpeechWrongGetStarted = (next) => {
  return [
    {
      id: "speech-wrong",
      target: ".select-microphone-devices",
      selector: ".select-microphone-devices",
      highlightedSelectors: [".select-microphone-devices"],
      mutationObservables: [".select-microphone-devices"],
      position: "center",
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          audioLink="you_seem_to_be_having_difficulties"
          textComponent={
            <Stack spacing={0.5}>
              <Typography textAlign={"center"}>
                <Trans i18nKey="you_seem_to_be_having_difficulties">
                  {t("you_seem_to_be_having_difficulties")}
                </Trans>
              </Typography>
              <Stack direction={"row"} spacing={0.5} justifyContent={"center"}>
                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  sx={nextStyles}
                  onClick={() => setIsOpen(false)}
                >
                  <Trans i18nKey="continue">{t("continue")}</Trans>
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  sx={nextStyles}
                  onClick={() => next()}
                >
                  <Trans i18nKey="complete_later">{t("complete_later")}</Trans>
                </Button>
              </Stack>
            </Stack>
          }
          image={10}
          imagePosition="right"
          onSkipClick={() => {
            setIsOpen(false)
          }}
          showImage
          forceShow
        />
      ),
      styles: popoverStyles,
    },
  ]
}

const SpeechSettingsGetStarted = (next) => {
  return [
    {
      id: "speech-settings",
      target: ".select-microphone-devices",
      selector: ".select-microphone-devices",
      highlightedSelectors: [".select-microphone-devices"],
      mutationObservables: [".select-microphone-devices"],
      position: "right",
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          text={"congratulations_green_lights_are_moving"}
          image={17}
          imagePosition="right"
          audioLink={"congratulations_green_lights_are_moving"}
          showImage
          showNextButton
          onNextClick={() => {
            setIsOpen(false)
            next()
          }}
          forceShow
          customImageStyle={{
            top: -170,
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      styles: popoverStyles,
    },
    // },
  ]
}

const SpeechSettingsGetStarted2 = (next) => {
  return [
    {
      id: "speech-settings",
      target: ".select-microphone-devices",
      selector: ".select-microphone-devices",
      highlightedSelectors: [".select-microphone-devices"],
      mutationObservables: [".select-microphone-devices"],
      position: "right",
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          forceShow
          text={"you_can_select_a_different_microphone"}
          image={11}
          imagePosition="right"
          audioLink={"you_can_select_a_different_microphone"}
          showImage
          showNextButton
          onNextClick={() => {
            setIsOpen(false)
            next()
          }}
          customImageStyle={{
            top: -170,
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      styles: popoverStyles,
    },
  ]
}

const SpeechLevelsGetStarted = [
  {
    id: "speech-levels",
    target: ".speech-level-basic",
    selector: ".speech-level-basic",
    highlightedSelectors: [".speech-level-basic"],
    mutationObservables: [".speech-level-basic"],
    position: "right",
    disableInteraction: true,
    stepInteraction: false,
    content: ({ setCurrentStep, currentStep, setIsOpen }) => (
      <GetStartedBuble
        forceShow
        text={"the_stars_indicate_the_level_of_difficulty"}
        image={10}
        imagePosition="right"
        audioLink={"the_stars_indicate_the_level_of_difficulty"}
        showImage
        showNextButton
        onNextClick={() => {
          setCurrentStep(currentStep + 1)
        }}
        customImageStyle={{
          top: -190,
          left: 260,
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
  },
  {
    id: "speech-levels",
    target: ".speech-button",
    selector: ".speech-button",
    highlightedSelectors: [".speech-button"],
    mutationObservables: [".speech-button"],
    position: "center",
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        forceShow
        textComponent={
          <Stack alignItems={"center"}>
            <Trans i18nKey="for_better_results_when_speaking">
              <Typography textAlign={"center"} color="primary">
                {t("for_better_results_when_speaking") + ":"}
              </Typography>
            </Trans>
            <Image name="microphone" width={80} height={80} />
            <Trans i18nKey="click_on_the_microphone_to_start_speaking_speak_clearly">
              <Typography textAlign={"center"}>
                {t("click_on_the_microphone_to_start_speaking_speak_clearly")}
              </Typography>
            </Trans>
          </Stack>
        }
        image={17}
        imagePosition="left"
        audioLink={"click_on_the_microphone_to_start_speaking_speak_clearly"}
        showImage
        customImageStyle={{
          right: 400,
        }}
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
  },
]

const EndModuleGetStarted = (next) => {
  return [
    {
      id: "end-module",
      target: ".module-skills",
      selector: ".module-skills",
      highlightedSelectors: [".module-skills"],
      mutationObservables: [".module-skills"],
      position: "left",
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          showImage
          image={15}
          text="pay_attention_to_your_grades_divided_by_skills"
          audioLink="pay_attention_to_your_grades_divided_by_skills"
          showNextButton
          forceShow
          imagePosition="left"
          onNextClick={() => {
            setIsOpen(false)
            next()
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
    },
  ]
}

const gradedByTeacherGetStarted = [
  {
    id: "graded-by-teacher",
    target: ".teacher-message-title",
    selector: ".teacher-message-title",
    highlightedSelectors: [".teacher-message-title"],
    mutationObservables: [".teacher-message-title"],
    position: "top",
    content: ({ setCurrentStep, currentStep }) => (
      <Stack alignItems={"center"}>
        <Trans i18nKey="you_can_see_your_teachers_comments_and_your_grade">
          <Typography textAlign={"center"}>
            {t("you_can_see_your_teachers_comments_and_your_grade")}
          </Typography>
        </Trans>
        <Button
          variant="contained"
          color="primary"
          disableElevation
          onClick={() => setCurrentStep(currentStep + 1)}
          sx={nextStyles}
        >
          <EastIcon />
        </Button>
      </Stack>
    ),
    styles: {
      popover: (base, state) => ({
        ...popoverStyles.popover(base, state),
        top: -36,
      }),
    },
  },
  {
    id: "graded-by-teacher",
    target: ".accept-btn",
    selector: ".accept-btn",
    highlightedSelectors: [".accept-btn"],
    mutationObservables: [".accept-btn"],
    position: "top",
    content: ({ setCurrentStep, currentStep }) => (
      <Stack alignItems={"center"}>
        <Trans i18nKey="you_can_see_your_teachers_comments_and_your_grade2">
          <Typography textAlign={"center"}>
            {t("you_can_see_your_teachers_comments_and_your_grade2")}
          </Typography>
        </Trans>
      </Stack>
    ),
    styles: popoverStyles,
  },
]

const teacherCommentsGetStarted = [
  {
    id: "test",
    selector: ".teacher-comments-view",
    highlightedSelectors: [".teacher-comments-view"],
    mutationObservables: [".teacher-comments-view"],
    content: ({ setIsOpen }) => (
      <GetStartedBuble
        text="actions_teacher_graded_activities_overview_03"
        showNextButton
        showAudio
        audioLink="actions_teacher_graded_activities_overview_03"
        onNextClick={() => {
          setIsOpen(false)
          if (window?.parent?.teacherGradeViewClosed) {
            window?.parent?.teacherGradeViewClosed()
          } else {
            console.log("function teacherGradeViewClosed doesn't exists")
          }
        }}
        showImage
        image={17}
        imagePosition="right"
        forceShow
        onSkipClick={() => {
          setIsOpen(false)
        }}
      />
    ),
    styles: popoverStyles,
    position: "right",
    disableInteraction: true,
    stepInteraction: false,
  },
]

const firstToolsGetStarted = ({
  setToolsOpen = () => {},
  setIsExplanationOpen = () => {},
  answerClick = () => {},
}) => {
  return [
    {
      id: "tools-menu",
      // target: ".tools-menu",
      selector: ".tools-menu",
      highlightedSelectors: [".menu-tools-paper"],
      mutationObservables: [".MuiList-root"],
      position: "top",
      disableInteraction: true,
      stepInteraction: false,
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          text="you_can_always_use_your_tools"
          audioLink="you_can_always_use_your_tools"
          showNextButton
          showAudio
          showImage
          image={6}
          imagePosition="left"
          onNextClick={() => {
            setToolsOpen(true)
            setTimeout(() => {
              setCurrentStep(currentStep + 1)
            }, 300)
          }}
          customImageStyle={{
            right: 400,
          }}
          forceShow
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      styles: popoverStyles,
    },
    {
      id: "tools-menu",
      target: ".explanation-tool-btn",
      selector: ".explanation-tool-btn",
      highlightedSelectors: [".explanation-tool-btn"],
      mutationObservables: [".explanation-tool-btn"],
      position: "left",
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          image={11}
          forceShow
          imagePosition="left"
          text="the_explanation_tool_always_has_something_good_for_you"
          audioLink="the_explanation_tool_always_has_something_good_for_you"
          showNextButton
          showAudio
          showImage
          onNextClick={() => {
            setToolsOpen(false)
            setIsExplanationOpen(true)
            setTimeout(() => {
              setCurrentStep(currentStep + 1)
            }, 300)
          }}
          customImageStyle={{
            right: 400,
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      styles: popoverStyles,
    },
    {
      id: "tools-menu",
      selector: ".activity-card-bottom",
      highlightedSelectors: [".activity-card-bottom"],
      mutationObservables: [".activity-card-bottom"],
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          text="you_can_hear_the_recording_see_how_it_is_written_and_see_the_translation"
          audioLink="you_can_hear_the_recording_see_how_it_is_written_and_see_the_translation"
          showNextButton
          showImage
          forceShow
          image={17}
          imagePosition="right"
          showAudio
          allowAutoNext={false}
          onNextClick={() => {
            setIsOpen(false)
            setIsExplanationOpen()
          }}
          customImageStyle={{
            left: 300,
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "top",
      showBadge: true,
      styles: popoverStyles,
    },
    {
      id: "tools-menu",
      target: ".answer-tool-btn",
      selector: ".answer-tool-btn",
      highlightedSelectors: [".answer-tool-btn"],
      mutationObservables: [".answer-tool-btn"],
      position: "left",
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          showImage
          image={15}
          imagePosition="left"
          text="the_answer_tool_ends_the_activity"
          audioLink="the_answer_tool_ends_the_activity"
          showNextButton
          showAudio
          forceShow
          allowAutoNext={false}
          onNextClick={() => {
            setToolsOpen(false)
            answerClick()
            setTimeout(() => {
              setCurrentStep(currentStep + 1)
            }, 300)
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      styles: popoverStyles,
    },
    {
      id: "tools-menu",
      selector: ".answer-expected",
      highlightedSelectors: [".answer-expected"],
      mutationObservables: [".answer-expected"],
      content: ({ currentStep, setCurrentStep, setIsOpen }) => (
        <GetStartedBuble
          text="smash_gives_you_the_expected_answer"
          audioLink="smash_gives_you_the_expected_answer"
          showNextButton
          showAudio
          showImage
          image={10}
          forceShow
          imagePosition="right"
          onNextClick={() => {
            setCurrentStep(currentStep + 1)
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "bottom",
      styles: {
        ...popoverStyles,
      },
    },
    {
      id: "tools-menu",
      selector: ".exercise-next",
      highlightedSelectors: [".exercise-next"],
      mutationObservables: [".exercise-next"],
      content: ({ currentStep, setCurrentStep, setIsOpen }) => (
        <GetStartedBuble
          text="continue_to_the_next_activity"
          audioLink="continue_to_the_next_activity"
          showAudio
          showImage
          forceShow
          image={10}
          imagePosition="right"
          customImageStyle={{
            top: -165,
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "right",
      styles: {
        ...popoverStyles,
      },
    },
  ]
}

const secondToolsGetStarted = ({
  setToolsOpen = () => {},
  setIsNoteOpen = () => {},
  setIsLibraryOpen = () => {},
  setIsExplanationOpen = () => {},
}) => {
  return [
    {
      id: "tools-menu-2",
      selector: ".tools-menu",
      highlightedSelectors: [".menu-tools-paper"],
      mutationObservables: [".MuiList-root"],
      position: "top",
      disableInteraction: true,
      stepInteraction: false,
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          text="the_tools_section_offers_two_amazing_tools"
          audioLink="the_tools_section_offers_two_amazing_tools"
          showNextButton
          showAudio
          showImage
          image={6}
          imagePosition="left"
          onNextClick={() => {
            setToolsOpen(true)
            setTimeout(() => {
              setCurrentStep(currentStep + 1)
            }, 300)
          }}
          customImageStyle={{
            right: 400,
          }}
          forceShow
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      styles: popoverStyles,
    },
    {
      id: "tools-menu-2",
      target: ".notes-tool-btn",
      selector: ".notes-tool-btn",
      highlightedSelectors: [".notes-tool-btn"],
      mutationObservables: [".notes-tool-btn"],
      disableInteraction: true,
      stepInteraction: false,
      position: "left",
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          image={11}
          forceShow
          imagePosition="left"
          text="the_first_one_is_your_notes"
          audioLink="the_first_one_is_your_notes"
          showNextButton
          showAudio
          showImage
          onNextClick={() => {
            setToolsOpen(false)
            setIsNoteOpen(true)
            setTimeout(() => {
              setCurrentStep(currentStep + 1)
            }, 300)
          }}
          customImageStyle={{
            right: 400,
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      styles: popoverStyles,
    },
    {
      id: "tools-menu-2",
      selector: "#student-take-notes-body-left",
      highlightedSelectors: ["#student-take-notes-body-left"],
      mutationObservables: ["#student-take-notes-body-left"],
      disableInteraction: true,
      stepInteraction: false,
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          text="you_can_organize_your_notes"
          audioLink="you_can_organize_your_notes"
          showNextButton
          showImage
          forceShow
          image={17}
          imagePosition="right"
          showAudio
          onNextClick={() => {
            setCurrentStep(currentStep + 1)
          }}
          customImageStyle={{
            left: 300,
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "right",
      showBadge: true,
      styles: popoverStyles,
    },
    {
      id: "tools-menu-2",
      target: "#stn-icons",
      selector: "#stn-icons",
      highlightedSelectors: ["#stn-icons"],
      mutationObservables: ["#stn-icons"],
      position: "bottom",
      disableInteraction: true,
      stepInteraction: false,
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          showImage
          image={15}
          imagePosition="left"
          text="you_can_recreate_new_notes_export_and_share"
          audioLink="you_can_recreate_new_notes_export_and_share"
          showNextButton
          showBackButton
          showAudio
          forceShow
          onBackClick={() => {
            setCurrentStep(currentStep - 1)
          }}
          onNextClick={() => {
            setIsNoteOpen(false)
            setToolsOpen(true)
            setTimeout(() => {
              setCurrentStep(currentStep + 1)
            }, 300)
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      styles: popoverStyles,
    },
    {
      id: "tools-menu-2",
      selector: ".library-tool-btn",
      highlightedSelectors: [".library-tool-btn"],
      mutationObservables: [".library-tool-btn"],
      disableInteraction: true,
      stepInteraction: false,
      content: ({ currentStep, setCurrentStep, setIsOpen }) => (
        <GetStartedBuble
          text="and_the_other_tool_is_library"
          audioLink="and_the_other_tool_is_library"
          showNextButton
          showAudio
          showImage
          image={10}
          forceShow
          imagePosition="left"
          onNextClick={() => {
            setIsOpen(false)
            setToolsOpen(false)
            setIsLibraryOpen(true)
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "left",
      styles: {
        ...popoverStyles,
      },
    },
    {
      id: "tools-menu-2",
      selector: ".explanation-button-2",
      highlightedSelectors: [".explanation-button-2"],
      mutationObservables: [".explanation-button-2"],
      content: ({ currentStep, setIsOpen }) => (
        <GetStartedBuble
          text="in_the_library_you_can_access_all_the_explanation"
          audioLink="in_the_library_you_can_access_all_the_explanation"
          showAudio
          showImage
          forceShow
          allowAutoNext={false}
          image={10}
          imagePosition="left"
          customImageStyle={{
            top: -165,
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "left",
      styles: {
        ...popoverStyles,
      },
    },
    {
      id: "tools-menu-2",
      selector: ".explanation-grammar-image",
      highlightedSelectors: [".explanation-grammar-image"],
      mutationObservables: [".explanation-grammar-image"],
      disableInteraction: true,
      stepInteraction: false,
      content: ({ setIsOpen }) => (
        <GetStartedBuble
          text="you_can_see_the_words_grammar_explanation"
          audioLink="you_can_see_the_words_grammar_explanation"
          showAudio
          showImage
          forceShow
          image={15}
          imagePosition="left"
          customImageStyle={{
            top: -165,
          }}
          onNextClick={() => {
            setIsOpen(false)
            setIsExplanationOpen(false)
            setIsLibraryOpen(false)
          }}
          showNextButton
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "center",
      styles: {
        ...popoverStyles,
      },
    },
  ]
}

const testGetStarted = [
  {
    id: "tools-menu",
    selector: ".exercise-next",
    highlightedSelectors: [".exercise-next"],
    mutationObservables: [".exercise-next"],
    content: ({ currentStep, setCurrentStep }) => (
      <Stack spacing={1}>
        {/* <Badge>{`${currentStep + 1}`}</Badge> */}
        <Typography>
          <Trans i18nKey={"continue_to_the_next_activity"}>
            {t("continue_to_the_next_activity")}
          </Trans>
        </Typography>
      </Stack>
    ),
    position: "right",
    styles: {
      ...popoverStyles,
    },
  },
]

export {
  firstToolsGetStarted,
  ExplanationGetStarted,
  ExplanationVideo,
  PictureQuestionGetStarted,
  MatchingPictureGetStarted,
  MatchingPictureForzedGetStarted,
  ListenAndChooseGetStarted,
  FindThePictureGetStarted,
  ListenAndFindThePictureGetStarted,
  MatchingGetStateted,
  ScrambledSentenceGetStarted,
  SoackedManGetStarted,
  WordsPronounciationGetStarted,
  SentencePronounciationGetStarted,
  InteractionsGetStated,
  FillingTheBlanksGetStated,
  FillingTheBlanksWriteGetStated,
  PictureAndQuestionWriteGetStarted,
  DictationGetStarted,
  OralComprehensionGetStarted,
  TextComprehensionGetStarted,
  RecordingComprehensionGetStarted,
  JustWriteGetStarted,
  JustWriteMultipleGetStarted,
  InterviewGetStarted,
  JustTalkGetStarted,
  EssayGetStarted,
  MultipleQuestionsGetStarted,
  ComparativeEssayGetStarted,
  SpeechSideGetStarted,
  SpeechSideGetStartedFirefox,
  SpeechSideNoMicGetStarted,
  SpeechSettingsGetStarted,
  SpeechSettingsGetStarted2,
  SpeechLevelsGetStarted,
  SpeechWrongGetStarted,
  EndModuleGetStarted,
  WrittenComprehensionGetStarted,
  gradedByTeacherGetStarted,
  teacherCommentsGetStarted,
  PictureQuestionGetStartedForzed,
  // PictureAndQuestionWriteAnswerGetStarted,
  ReadingOutloudGetStarted,
  InterviewGetStarted2,
  testGetStarted,
  PictureAndQuestionWriteGetStartedForzed,
  InterviewForcedGetStarted,
  secondToolsGetStarted,
}
